import { jsx as x } from "react/jsx-runtime";
import { useController as C } from "react-hook-form";
import { Input as v } from "../input/input.js";
import { useTranslation as T } from "react-i18next";
import { getErrorMessage as q } from "./hook-form-helper.js";
import { useEffect as B } from "react";
const H = ({
  rules: o,
  control: n,
  name: i,
  label: m,
  className: s,
  helperText: f,
  placeholder: a,
  autoComplete: l,
  inputMode: u,
  isReadOnly: p,
  isDisabled: t,
  defaultValue: e
}) => {
  const { t: d } = T(), { field: r, fieldState: g } = C({
    name: i,
    control: n,
    defaultValue: e,
    disabled: t,
    rules: o,
    shouldUnregister: !0
  });
  B(() => {
    e && r.onChange(e);
  }, []);
  const { invalid: c, error: h } = g;
  return /* @__PURE__ */ x(
    v.Text,
    {
      className: s,
      label: m,
      onChange: r.onChange,
      onBlur: r.onBlur,
      name: r.name,
      value: r.value,
      fieldRef: r.ref,
      isValid: !c,
      isRequired: !!o?.required,
      errorText: q(d, h),
      helperText: f,
      placeholder: a,
      autoComplete: l,
      inputMode: u,
      isReadOnly: p,
      isDisabled: t
    }
  );
};
export {
  H as HookFormInputField
};
